<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text mr-2" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <v-toolbar-title>
                <h2>Lista de comisiones</h2>
            </v-toolbar-title>
        </v-toolbar>

        <v-row class="mt-2">
            <v-col cols="12" md="4">
                <v-autocomplete
                    label="Comercial"
                    v-model="filters.id_agente"
                    :items="Agentes"
                    item-value="id"
                    item-text="nombre"
                >
                </v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="filters.fecha"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="month_format"
                            label="Seleccionar mes"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.fecha"
                        type="month"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(filters.fecha)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <div class="d-flex justify-end mb-4">
            <card-total
                :titulo="'Total ventas'"
                :total="totales.total_venta"
                :comision="totales.per_ventas"
            ></card-total>

            <card-total
                :titulo="'Ventas trimestre'"
                :total="totales.trimestre"
                :comision="totales.per_trimestre"
            ></card-total>

            <card-total
                :titulo="'Total cobros'"
                :total="totales.total_cobros"
                :comision="totales.per_cobros"
            ></card-total>

            <card-total
                :titulo="'Cobros trimestre'"
                :total="totales.cobros_tri"
                :comision="totales.per_cobros_tri"
            ></card-total>

            <card-total
                :titulo="'Totales mensuales'"
                :total="totales.total"
                :comision="totales.per_total"
            ></card-total>
        </div>

        <v-data-table
            dense
            :headers="headers"
            :items="comisiones"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
        </v-data-table>
    </v-card>
</template>
<script>
import FilterComponent from "../../../components/general/FilterComponent.vue";
import cardTotal from "./cardTotal.vue";
import moment from "moment";
export default {
    components: {
        FilterComponent,
        cardTotal,
    },
    data() {
        return {
            totales: {
                trimestre: 0,
                per_trimestre: 0,
                total_venta: 0,
                total_cobros: 0,
                per_ventas: 0,
                per_cobros: 0,
                total: 0,
                per_total: 0,
                cobros_tri: 0,
                per_cobros_tri: 0,
            },
            search: "",
            menu: false,
            filters: {
                fecha: new Date().toISOString().substr(0, 7),
                id_agente: null,
            },
            headers: [
                {
                    text: "Comercial",
                    value: "comercial",
                    sortable: false,
                },
                {
                    text: "Importe sin impuestos",
                    value: "importe",
                    sortable: false,
                },
                {
                    text: "Presupuesto",
                    value: "presupuesto",
                    sortable: false,
                },
                {
                    text: "Tipo de comisión",
                    value: "tipo_comision",
                    sortable: false,
                },
            ],
            Agentes: [],
            comisiones: [],
        };
    },

    watch: {
        filters: {
            deep: true,
            handler: function (n) {
                this.getComisiones(n);
            },
        },
    },

    created() {
        this.getAgentes();
        //this.getComisiones()
    },

    methods: {
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.Agentes = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
        getComisiones(filters) {
            axios.post(`api/get-comisiones-empresa/`, filters).then(
                (res) => {
                    this.comisiones = res.data.map;
                    this.totales = res.data.totales;
                },
                (err) => {
                    this.$custom_error("Error consultando las comisiones");
                }
            );
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
        month_format: function () {
            return moment(`${this.filters.fecha}/01`).format("MM/YYYY");
        },
    },
};
</script>
